function matchedAllElements(segments: string[], text: string, start: number, end: number) {
  const range = text.slice(start, end);
  return segments.filter((seg) => range.includes(seg)).length;
}

function rangeHighlight(query: string, html: string) {
  const segments = query.split(' ');
  const minMatchedSegments = segments.length ?? 0;

  if (segments.length === 0) return { start: 0, end: 0 };

  let minLength = html.length;
  let bestStart = 0;
  let bestEnd = html.length - 1;

  let reached = false;

  // Sliding window approach
  let left = 0;
  let right = html.length;

  let scored = matchedAllElements(segments, html, left, right) === minMatchedSegments;

  if (!scored) return { start: 0, end: 0 };

  while (scored) {
    scored = matchedAllElements(segments, html, left, right) === minMatchedSegments;
    const nowLenght = html.slice(left, right).length;

    if (nowLenght < minLength && scored) {
      bestStart = left;
      bestEnd = right;
      minLength = nowLenght;
    }

    if (!scored && !reached) {
      scored = true;
      reached = true;
      --left;
    }

    // Move the pointer with the smaller value
    if (scored && !reached) left++;
    else right--;
  }

  return { start: bestStart, end: bestEnd };
}

const getTextNearTags = ({ start, end }: { start: number; end: number }, html: string) => {
  function findClosingTagBefore(inputString: string, initialPos: number) {
    // Start from the initial position
    let pos = initialPos;

    // Go back, skipping empty characters (spaces, tabs, newlines)
    while (pos >= 0) {
      const char = inputString[pos];

      if (char === ' ' || char === '\t' || char === '\n' || char === '\r') {
        pos--;
        continue;
      }

      // If we find ">", continue going back to find "<"
      if (char === '>') {
        pos--;

        // Keep going back to find the first "<"
        while (pos >= 0) {
          const currentChar = inputString[pos];

          if (currentChar === '<') {
            // Check if the next forward character is "/"
            if (pos + 1 < inputString.length && inputString[pos + 1] === '/') {
              // Return the position initial pos
              return initialPos;
            }
            // If not a closing tag, break and return
            return pos;
          }
          pos--;
        }
        continue;
      }

      // If we encounter any other character
      break;
    }

    // Return initialPos if no closing tag found
    return initialPos;
  }

  function findClosingTagAfter(inputString: string, initialPos: number) {
    // Start from the initial position
    let pos = initialPos;

    // Go back, skipping empty characters (spaces, tabs, newlines)
    while (pos <= inputString.length) {
      const char = inputString[pos];

      if (char === ' ' || char === '\t' || char === '\n' || char === '\r') {
        pos++;
        continue;
      }

      // If we find "<", continue going back to find ">"
      if (char === '<' && pos + 1 < inputString.length && inputString[pos + 1] === '/') {
        pos++;

        // Keep going back to find the first "<"
        while (pos <= inputString.length) {
          const currentChar = inputString[pos];

          if (currentChar === '>') {
            // Check if the char is ">"
            return pos + 1;
          }
          pos++;
        }
        continue;
      }

      // If we encounter any other character
      break;
    }

    // Return initialPos if no closing tag found
    return initialPos;
  }

  return { start: findClosingTagBefore(html, start), end: findClosingTagAfter(html, end) };
};

export const getTextBetweenMatch = (query: string, html: string) =>
  getTextNearTags(rangeHighlight(query, html), html);
